import { axiosClient } from "../api/axiosClient";

export type UsageLevel = 0 | 1 | 2 | 3;

export type UsageHeatmapDay = {
  date: string;
  opened: boolean;
  actionCount: number;
  level: UsageLevel;
  future: boolean;
};

export type UsageHeatmapResponse = {
  timezone: string;
  from: string;
  to: string;
  today: string;
  weeks: number;
  days: UsageHeatmapDay[];
  summary: {
    activeDays: number;
    streak: number;
    actionCount: number;
  };
};

export type DailyAccessResponse = {
  accessDate: string;
  created: boolean;
};

export const USAGE_HEATMAP_WEEKS = 16;

const DAILY_ACCESS_STORAGE_KEY = "ilovemacumba_daily_access_date";

export const saoPauloDateKey = (date: Date): string =>
  new Intl.DateTimeFormat("en-CA", {
    timeZone: "America/Sao_Paulo",
    year: "numeric",
    month: "2-digit",
    day: "numeric",
  }).format(date);

export const usageHeatmapRepository = {
  recordDailyAccess: async (): Promise<DailyAccessResponse> => {
    const { data } = await axiosClient.post<DailyAccessResponse>("/me/daily-access");
    return data;
  },

  getUsageHeatmap: async (
    weeks = USAGE_HEATMAP_WEEKS,
  ): Promise<UsageHeatmapResponse> => {
    const { data } = await axiosClient.get<UsageHeatmapResponse>(
      "/me/usage-heatmap",
      { params: { weeks } },
    );
    return data;
  },
};

export const readStoredDailyAccessDate = (): string | null => {
  try {
    return sessionStorage.getItem(DAILY_ACCESS_STORAGE_KEY);
  } catch {
    return null;
  }
};

export const storeDailyAccessDate = (accessDate: string): void => {
  try {
    sessionStorage.setItem(DAILY_ACCESS_STORAGE_KEY, accessDate);
  } catch {
    // Private mode can block sessionStorage. The next navigation can retry.
  }
};
